// removed by extract-text-webpack-plugin
module.exports = {"TermOfServices":"StaticPage__TermOfServices__2ci1Y","PrivacyPolicy":"StaticPage__PrivacyPolicy__1YrMs","FQA":"StaticPage__FQA__11hC5","Question":"StaticPage__Question__2TXCw","Answer":"StaticPage__Answer__XpcF-","AnswerImage":"StaticPage__AnswerImage__1_GjU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/StaticPage/StaticPage.css
// module id = 282
// module chunks = 0